import {
  partners,
  services,
  customers,
  footprint,
  scheduling,
  tickets,
  documents,
  settings,
  reports
} from './main-dashboard'

export const mainDashboard = [
  partners,
  services,
  customers,
  footprint,
  scheduling,
  tickets,
  documents,
  settings,
  reports
]
